import { AxiosInstance } from "../../axios/axiosInstance"
import { apiRoutes } from "../../utils/ApiRoutes"
import { ISearchBusinessData } from "./IApisInterface"

export const searchBusinessApi = async (payload: ISearchBusinessData) => {
    const response = await AxiosInstance.post(apiRoutes?.businessSearch, payload)
    return response
}

export const getExportDataApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.businessExport)
    return response
}

export const getConfigurationApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.getConfiguration)
    return response
}